<button
    *ngIf="canViewBilling"
    type="button"
    class="btn btn-golden {{ buttonClasses }}"
    angulartics2On="click"
    angularticsAction="daily-operations-upgrade"
    angularticsCategory="subscriptions"
    relativeRouterLink="orgadmin/subscriptions"
    [tooltip]="text"
    [placement]="tooltipPlacement"
>
    Upgrade
</button>
